import { Button, IconArrowLineUp, Tooltip } from '@vtex/admin-ui'
import { FormState, useWatch } from '@vtex/admin-ui-form'
import { useToast } from 'hooks'
import { useIntl } from 'react-intl'
import { Item } from 'typings'
import { FileInput } from '../../../FileInput'
import { getNewIds, parseIds } from '../../../utils'
import messages from './messages'
import { fileValidationSuite } from './validation'

export type Importer = (ids: string[]) => Promise<{
  found: number
  notFound: number
  items: Item[]
}>

interface Props {
  name: string
  form: FormState
  importer: Importer
  maxEntries: number
}

export function ImportButton(props: Props) {
  const { name, form, importer, maxEntries } = props

  const values: Item[] = useWatch({ form, name })

  const intl = useIntl()

  const { $t } = intl

  const { infoToast, errorToast, positiveToast } = useToast()

  const handleUpload = async (fileContent: string) => {
    const ids = parseIds(fileContent)

    const idsToImport = getNewIds(
      values.map((v) => v.id),
      ids
    )

    const suite = fileValidationSuite(intl, maxEntries - values.length)
    const result = suite(idsToImport)

    if (!result.valid) {
      result.errors[0].message &&
        errorToast(result.errors[0].message as string, 'import')
      return
    }

    infoToast($t(messages.start), 'import')

    const { found, notFound, items } = await importer(idsToImport)

    items.length && form.setValue(name, [...values, ...items])

    positiveToast($t(messages.success, { found, notFound }), 'import')
  }

  return (
    <FileInput
      id={`input-file-${name}`}
      onChange={handleUpload}
      onError={() => errorToast($t(messages.error))}
    >
      <Tooltip text={$t(messages.upload)}>
        <Button
          variant="neutralTertiary"
          icon={<IconArrowLineUp />}
          aria-label={$t(messages.upload)}
        />
      </Tooltip>
    </FileInput>
  )
}
